(function () {
  'use strict';

  /* global $, document */
  class HeaderCtrl {

    constructor(Uos, $timeout, FeatureFlag, SolucoesEnum, Authenticator, $window, FeaturehubJsSdk, FeatureHubConfigKeys, FeatureOuService) {
      this.sistema = 'core-conducaoeconomica';
      this.featureFlag = FeatureFlag;
      this.solucoesEnum = SolucoesEnum;
      this.authenticator = Authenticator;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.featureOuService = FeatureOuService;
      this.window = $window;
      this.showMenu = true;
      if (this.window.parent) {
        this.window.parent.postMessage({origin: 'vfleets', type: 'loaded'}, '*');
      }

      this.uo = {
        id: -1,
        nome: 'Carregando UOs...'
      };
      Uos.getFilhas().then(data => angular.extend(this.uo, data.plain()));

      $timeout(() => {
        $.AdminLTE.tree('.sidebar');
      });
      this.isGestaoOcorrenciaEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.GESTAO_OCORRENCIA_FLAG);

      this.authenticator.getUser().then(user => {
        const localStrgBuscaRegiao = this.window.localStorage.getItem('tutorial-busca-regiao');
        if (user.permissoes.includes('VPLAYER_DOWNLOAD_VISUALIZAR')) {
          this.notificationVideoDownload(user);
        }
        this.featureOuService.getWhatsNewConfig(user.uo && user.uo.id)
          .then(whatsNew => {
            this.showVersion = !!whatsNew;
            this.showModalTutorialBuscaRegiao = (localStrgBuscaRegiao === null || localStrgBuscaRegiao < new Date()) &&
              !!whatsNew &&
              this.featureFlag.TUTORIAL_BUSCA_REGIAO;
          })
          .catch(() => {
            this.showVersion = false;
            this.showModalTutorialBuscaRegiao = false;
          });
        this.initHeader(user.isNa);
      });
    }

    initHeader(isNa) {
      const deviceHealthMenu = isNa
        ? {label: 'ce.tempoReal.deviceHealth.menuLabel', state: 'root.device-health', role: 'SAUDE_DO_EQUIPAMENTO'}
        : {label: 'ce.tempoReal.vehicleHealth.menuLabel', state: 'root.vehicle-health', role: 'SAUDE_DO_EQUIPAMENTO'},
          coachingMenu = this.featurehubJsSdk.isFeatureEnabled('PVS_187_COACHING_PAGE_NAVIGATION') && isNa &&
            {label: 'ce.tempoReal.coaching.menuLabel', state: 'root.coaching', role: 'COACHING_PAGE_VISUALIZAR'},
          coachingPortalMenu = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_COACHING_PORTAL) &&
            {label: 'ce.tempoReal.coachingPortal.menuLabel', state: 'root.coachingPortal', role: 'COACHING_PAGE_VISUALIZAR'};
      this.menu = [
        {
          label: 'ce.indicadores.menuLabel', icon: 'fa-bar-chart', roles: ['CONDUCAO_ECONOMICA_VISUALIZAR', 'DIRECAO_SEGURA_VISUALIZAR', 'OCIOSIDADE_FROTA_VISUALIZAR', 'INDICADOR_POWER_BI_VISUALIZAR', 'ROTA_VISUALIZAR'],
          submenu: [
            {label: 'ce.indicadores.conducaoEconomica.menuLabel', state: 'root.conducaoEconomica', role: 'CONDUCAO_ECONOMICA_VISUALIZAR'},
            {label: 'ce.indicadores.direcaoSegura.menuLabel', state: 'root.direcaoSegura', role: 'DIRECAO_SEGURA_VISUALIZAR'},
            {label: 'ce.indicadores.ociosidadeFrota.menuLabel', state: 'root.utilizacaoVeiculo', role: 'OCIOSIDADE_FROTA_VISUALIZAR'},
            !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX_297_productivity_indicators') && {label: 'ce.indicadores.productivityIndicators.menuLabel', state: 'root.productivity-indicators', role: 'ROTA_VISUALIZAR'},
            {label: 'BI', state: 'root.indicadorPowerBi', role: 'INDICADOR_POWER_BI_VISUALIZAR'}
          ].filter(Boolean)
        },
        {
          label: 'ce.tempoReal.menuLabel', icon: 'trimble-icon trimble-real-time', roles: [
            'OCORRENCIA_VISUALIZAR', 'ONE_PAGE_VISUALIZAR', 'RANKING_INFRACOES_VISUALIZAR', 'SAUDE_DO_EQUIPAMENTO', 'MACRO_VISUALIZAR', 'ROTA_VISUALIZAR',
            (coachingMenu || coachingPortalMenu) && 'COACHING_PAGE_VISUALIZAR'
          ].filter(Boolean),
          submenu: [
            {label: 'ce.tempoReal.quadroDeOcorrencias.menuLabel', state: 'root.quadroOcorrencias', role: 'OCORRENCIA_VISUALIZAR'},
            this.isGestaoOcorrenciaEnabled && !isNa && {label: 'ce.tempoReal.gestaoOcorrencia.menuLabel', state: 'root.gestaoOcorrencias', role: 'OCORRENCIA_VISUALIZAR'},
            {label: 'ce.tempoReal.statusFrota.menuLabel', state: 'root.onePage', role: 'ONE_PAGE_VISUALIZAR'},
            this.featurehubJsSdk.isFeatureEnabled('STFM-1371-DeviceHealth') && deviceHealthMenu,
            coachingMenu,
            coachingPortalMenu,
            {label: 'ce.tempoReal.infracoes.menuLabel', state: 'root.rankingInfracoes', role: 'RANKING_INFRACOES_VISUALIZAR'},
            !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX-251_productivity') && {
              label: 'ce.tempoReal.productivityReport.menuLabel', state: 'root.productivity-report', roles: [
                'MACRO_VISUALIZAR', 'ROTA_VISUALIZAR']
            }
          ].filter(Boolean)
        },
        {
          label: 'ce.ranking.menuLabel', icon: 'fa-sort-amount-desc', roles: ['RANKING_GERAL_VISUALIZAR', 'RANKING_ECONOMIA_VISUALIZAR', 'RANKING_SEGURANCA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR'],
          submenu: [
            {label: 'ce.ranking.pontos.menuLabel', state: 'root.rankingPontos', roles: [['RANKING_GERAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]},
            {label: 'ce.ranking.conducaoEconomica.menuLabel', state: 'root.rankingEconomy', role: 'RANKING_ECONOMIA_VISUALIZAR'},
            {label: 'ce.ranking.direcaoSegura.menuLabel', state: 'root.rankingSafety', role: 'RANKING_SEGURANCA_VISUALIZAR'}
          ]
        },
        {
          label: 'ce.boletim.menuLabel', icon: 'fa-list-alt', roles: ['BOLETIM_MOTORISTA_VISUALIZAR', 'BOLETIM_VEICULO_VISUALIZAR', 'BOLETIM_SERVICO_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR'],
          submenu: [
            {
              label: 'ce.boletim.diarioMotorista.menuLabel',
              state: 'root.bdm',
              roles: [['BOLETIM_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
            },
            {label: 'ce.boletim.diarioVeiculo.menuLabel', state: 'root.bdv', role: 'BOLETIM_VEICULO_VISUALIZAR'},
            {label: 'ce.boletim.abastecimento.menuLabel', state: 'root.abastecimento', role: 'HISTORICO_ABASTECIMENTO_VISUALIZAR'},
            {label: 'ce.boletim.servicos.menuLabel', state: 'root.bds', role: 'BOLETIM_SERVICO_VISUALIZAR'}
          ]
        },
        {
          label: 'ce.analise.menuLabel',
          icon: 'fa-line-chart',
          roles: [
            'HISTORICO_CONSOLIDADO_VISUALIZAR',
            'HISTORICO_ALERTA_VISUALIZAR',
            'PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR',
            'PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR',
            'ANALISE_VELOCIDADE_RPM_PARABRISA_VISUALIZAR',
            'SAUDE_FROTA_VISUALIZAR',
            'MOTORISTA_MENU_VISUALIZAR',
            'DADOS_SENSIVEIS_VISUALIZAR',
            'VPLAYER_REQMANUAL_VISUALIZAR'
          ],
          submenu: [
            !isNa && {label: 'ce.analise.movimentoVeiculo.menuLabel', state: 'root.analiseOp', role: 'HISTORICO_CONSOLIDADO_VISUALIZAR'},
            {label: 'ce.analise.permanencia.menuLabel', state: 'root.permanencia', roles: ['PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR', 'PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR']},
            {label: 'ce.analise.alertas.menuLabel', state: 'root.historicoAlerta', role: 'HISTORICO_ALERTA_VISUALIZAR'},
            {
              label: 'ce.analise.solicitacoesAgendadas.menuLabel',
              state: 'root.historicoSolicitacao',
              roles: ['SOLICITACAO_AGENDADA_VISUALIZAR']
            },
            {label: 'ce.analise.velocidadeXrpm.menuLabel', state: 'root.velocidadeRpm', role: 'ANALISE_VELOCIDADE_RPM_PARABRISA_VISUALIZAR'},
            {label: 'ce.analise.saudeDaFrota.menuLabel', state: 'root.saudeFrota', role: 'SAUDE_FROTA_VISUALIZAR'},
            {
              label: 'ce.analise.identificacoes.menuLabel',
              state: 'root.identificacoes',
              roles: [['IDENTIFICACOES_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
            }
          ].filter(Boolean)
        },
        {
          label: 'ce.mapa.menuLabel', icon: 'fa-map', roles: ['LOCALIZACAO_ATUAL_VISUALIZAR', 'HISTORICO_DETALHADO_VISUALIZAR'],
          submenu: [
            {label: 'ce.mapa.localizacaoDaFrota.menuLabel', state: 'root.mapasGrid', role: 'LOCALIZACAO_ATUAL_VISUALIZAR'},
            {label: 'ce.mapa.historicoDetalhado.menuLabel', state: 'root.historicoTimeline', role: 'HISTORICO_DETALHADO_VISUALIZAR'},
            {label: 'ce.mapa.mapaDeCalor.menuLabel', state: 'root.mapaCalor', role: 'MAPA_DE_CALOR_VISUALIZAR'}
          ]
        },
        {
          label: 'ce.cadastro.menuLabel', icon: 'fa-pencil-square-o', roles: ['MOTORISTA_MENU_VISUALIZAR', 'VEICULO_VISUALIZAR', 'PONTO_REFERENCIA_VISUALIZAR', 'MACRO_VISUALIZAR'],
          submenu: [
            {label: 'ce.cadastro.motoristas.menuLabel', state: 'root.motorista', roles: [['MOTORISTA_MENU_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]},
            {label: 'ce.cadastro.veiculos.menuLabel', state: 'root.veiculo', role: 'VEICULO_VISUALIZAR'},
            {label: 'ce.cadastro.grupoDeVeiculos.menuLabel', state: 'root.grupoVeic', role: 'GRUPO_VEICULO_VISUALIZAR'},
            {label: 'ce.cadastro.pontosReferencia.menuLabel', state: 'root.pontoReferencia', role: 'PONTO_REFERENCIA_VISUALIZAR'},
            !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX-205_cadastro-macros') && {label: 'ce.cadastro.macro.title', state: 'root.macro', role: 'MACRO_VISUALIZAR'}
          ].filter(Boolean)
        },
        {
          label: 'ce.configuracao.menuLabel', icon: 'fa-cog', roles: ['CONFIGURACAO_ALERTA_VISUALIZAR', 'CONFIG_VDRIVERS_VISUALIZAR', 'VEHICLE_SETTINGS_VIEW'],
          submenu: [
            {label: 'ce.configuracao.eventos.menuLabel', state: 'root.configEventos', role: 'CONFIGURACAO_ALERTA_VISUALIZAR'},
            {label: 'ce.configuracao.biReport.menu', state: 'root.biReport', role: 'ADMIN_VELTEC'},
            {label: 'Vdrivers', state: 'root.configVdrivers', role: 'CONFIG_VDRIVERS_VISUALIZAR'},
            isNa && this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VEHICLE_SETTINGS_PAGE) &&
            {label: 'ce.configuracao.vehicleSettings.menuLabel', state: 'root.vehicleSettings', role: 'VEHICLE_SETTINGS_VIEW'}
          ].filter(Boolean)
        }
      ];

      this.addDuoRoutesMenu();
      this.addVideoLibrary();
      this.addMenuInsights();
      this.addVfleets2Menu();
    }

    addVfleets2Menu() {
      if (this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VFLEETS2_MENU_ITEM)) {
        this.menu.push({
          label: 'Vfleets 2.0',
          icon: 'material-icons launch',
          submenu: [
            {label: 'Vfleets 2.0', state: 'root.vfleets2'}
          ]
        });
      }
    }

    addVideoLibrary() {
      const indiceMenuAnalise = 4,
          indiceSubmenuVideoLibrary = 4,
          isVideoHistoryHidden = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.HIDE_VIDEO_HISTORY_MENU);
      this.authenticator.getUser().then((user) => {
        if (user.permissoes.indexOf('VPLAYER_REQMANUAL_VISUALIZAR') !== -1 && !isVideoHistoryHidden) {
          this.menu[indiceMenuAnalise].submenu.splice(indiceSubmenuVideoLibrary, 0, {
            label: 'ce.analise.videoLibrary.menuLabel',
            state: 'root.videoLibrary.solicitacaoVideos',
            roles: [['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
          });
        }

        if (user.permissoes.indexOf('VIDEO_PLAYBACK') !== -1 || user.permissoes.indexOf('VPLAYER_REQMANUAL_VISUALIZAR') !== -1) {
          this.menu[indiceMenuAnalise].submenu.splice(indiceSubmenuVideoLibrary, 0, {
            label: 'ce.analise.videoPlayback.menuLabel',
            state: 'root.playback',
            roles: ['VIDEO_PLAYBACK', ['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
          });
        }
      });
    }

    addMenuInsights() {
      this.authenticator.getUser().then((user) => {
        if (this.featureFlag.MENU_INSIGHTS) {
          if (user.permissoesSolucao.indexOf('PREDICAO_ACIDENTE_VISUALIZAR') !== -1) {
            this.menu.splice(8, 0, {
              label: 'Insights', icon: 'trimble-icon trimble-ps-logo', roles: ['PREDICAO_ACIDENTE_VISUALIZAR'],
              submenu: [
                {label: 'ce.insights.seguranca.menuLabel', state: 'root.insights', roles: [['PREDICAO_ACIDENTE_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]}
              ]
            });
          }
        }
      });
    }

    addDuoRoutesMenu() {
      this.authenticator.getUser().then((user) => {
        if (user.isNa) {
          return;
        }

        const cadastroMenuIndex = this.menu.findIndex(item => item.label === 'ce.cadastro.menuLabel');
        this.menu.splice(cadastroMenuIndex, 0, {
          label: 'ce.duoRoutes.menuLabel',
          icon: 'material-icons route',
          roles: ['ROTA_VISUALIZAR', 'ATRIBUICAO_ROTA_VISUALIZAR'],
          submenu: [
            {label: 'ce.duoRoutes.cadastroRotas.menuLabel', state: 'root.duo-routes-cadastro', role: 'ROTA_VISUALIZAR'},
            {label: 'ce.duoRoutes.atribuicao.menuLabel', state: 'root.duo-routes-atribuicao', role: 'ATRIBUICAO_ROTA_VISUALIZAR'}
          ].filter(Boolean)
        });
      });
    }

    notificationVideoDownload(user) {
      /* eslint-disable */
      const notificationVideoDownloadElement = document.querySelector('#notification-video-download'),
        vfwcNotificationVideoDownloadElement = document.createElement('vfwc-notification-video-download'); /* eslint-enable */
      vfwcNotificationVideoDownloadElement.user = user;
      notificationVideoDownloadElement.appendChild(vfwcNotificationVideoDownloadElement);
    }
  }
  angular
    .module('headerModule', ['FeatureFlagModule', 'uoModule', 'SolucoesModule', 'v3gAuthenticatorModule'])
    .controller('HeaderCtrl', HeaderCtrl);
}());
